<script lang="ts" setup>
import type { HintSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: HintSectionRecord; pageTitle: string; currentPageId: string }>();
</script>

<template>
  <HintAlert :id="data.id" :title="data.optTitle ?? undefined" :description="data.description" />
</template>

<style scoped>

</style>
